<fuse-card class="flex w-full max-w-180 flex-col pb-4 sm:pb-6">
    <div class="flex flex-row items-center gap-2 p-4">
        <mat-icon [svgIcon]="'heroicons_outline:clock'"></mat-icon>
        <div class="flex grow flex-col">
            <div class="text-lg font-bold">Jobs</div>
        </div>
        <button
            mat-stroked-button
            (click)="refreshJobs()"
            [disabled]="jobsLoading"
        >
            <mat-spinner *ngIf="jobsLoading" [diameter]="20"></mat-spinner>
            <mat-icon *ngIf="!jobsLoading" svgIcon="refresh"></mat-icon>
            <span class="ml-2 mr-1">Refresh</span>
        </button>
    </div>

    <div class="relative px-4 pt-4 sm:px-6">
        <div
            *ngIf="jobsLoading && jobs.length === 0"
            class="flex justify-center py-8"
        >
            <mat-spinner [diameter]="32"></mat-spinner>
        </div>
        <div
            *ngIf="!jobsLoading && jobs.length === 0"
            class="text-secondary py-8 text-center"
        >
            No jobs found.
        </div>
        <ng-container *ngIf="jobs.length > 0">
            <div
                class="bg-card flex flex-col overflow-hidden rounded-xl border border-slate-300"
                [class.opacity-50]="jobsLoading"
            >
                <div
                    *ngFor="let job of jobs"
                    class="flex flex-col gap-1 border-b border-slate-200 px-4 py-3 last:border-b-0 sm:flex-row sm:items-center sm:gap-4"
                >
                    <div class="min-w-0 flex-auto">
                        <div class="font-medium">
                            {{ job.jobType?.name }}
                        </div>
                        <div class="text-secondary truncate text-sm">
                            {{ job.id }}
                        </div>
                    </div>
                    <div class="flex flex-wrap gap-x-4 gap-y-1 text-sm">
                        <span *ngIf="job.jobStatusType?.name">
                            <span class="text-secondary">Status:</span>
                            {{ job.jobStatusType.name }}
                        </span>
                        <span *ngIf="job.jobQueue?.name">
                            <span class="text-secondary">Queue:</span>
                            {{ job.jobQueue.name }}
                        </span>
                        <span *ngIf="job.jobPriorityType?.name">
                            <span class="text-secondary">Priority:</span>
                            {{ job.jobPriorityType.name }}
                        </span>
                        <span *ngIf="job.matchedLeadsProduct?.name">
                            <span class="text-secondary">Product:</span>
                            {{ job.matchedLeadsProduct.name }}
                        </span>
                        <span>
                            <span class="text-secondary">Attempts:</span>
                            {{ job.attempts }}/{{ job.maxAttempts }}
                        </span>
                        <span>
                            <span class="text-secondary">Created:</span>
                            {{ job.createdAt | date : "short" }}
                        </span>
                        <span *ngIf="job.matchedLeadsProduct?.id">
                            <span class="text-secondary"
                                >Matched Leads Product:</span
                            >
                            {{ job.matchedLeadsProduct.id }}
                        </span>
                    </div>
                    <div *ngIf="job.failedReason" class="text-sm text-warn">
                        {{ job.failedReason }}
                    </div>
                </div>
            </div>
            <div
                *ngIf="jobsLoading"
                class="absolute inset-0 flex items-center justify-center"
            >
                <mat-spinner [diameter]="32"></mat-spinner>
            </div>
        </ng-container>
    </div>
</fuse-card>
